import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Leaderboard from "./pages/leaderboards";
import Landing from "./pages/landing";
import Profile from "./pages/profile";
import Store from "./pages/store";
import Tables from "./pages/tables";
import TeamHub from "./pages/team-hub";
import Transfers from "./pages/transfers";
import Admin from "./pages/admin";
import "./App.css";
import "./styles.sass";
import { UserProvider } from "./context/useUser";
import { LeagueProvider } from "./context/useLeague";
import AuthenticatedRoute from './components/auth/AuthenticatedRoute';
import AdminRoute from "./components/auth/AdminRoute";


function App() {
  return (
    <UserProvider>
      <LeagueProvider>
        <>
          {/* Dedicated background grid layer */}
          <div className="vgc-background-grid" />
          <Router>
            <Routes>
              {/* Public routes */}
              <Route path="/" element={<Landing />}></Route>
              {/* Authenticated routes */}
              <Route path="/leaderboard" element={<AuthenticatedRoute><Leaderboard /></AuthenticatedRoute>}></Route>
              <Route path="/profile" element={<AuthenticatedRoute><Profile /></AuthenticatedRoute>}></Route>
              <Route path="/store" element={<AuthenticatedRoute><Store /></AuthenticatedRoute>}></Route>
              <Route path="/tables" element={<AuthenticatedRoute><Tables /></AuthenticatedRoute>}></Route>
              <Route path="/teamhub" element={
                <AuthenticatedRoute>
                  <TeamHub />
                </AuthenticatedRoute>
              }
              ></Route>
              <Route path="/transfers" element={<AuthenticatedRoute><Transfers /></AuthenticatedRoute>}></Route>
              {/* Admin routes */}
              <Route path="/admin" element={<AdminRoute><Admin /></AdminRoute>}></Route>
            </Routes>
          </Router>
        </>
      </LeagueProvider>
    </UserProvider>
  );
}

export default App;
